export default function () {
  this.doLoadAll()
}



// WEBPACK FOOTER //
// ./src/crud/index/resources/mounted.js